module.exports = require("@nestjs/microservices");